exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ol-control.ol-overview{position:absolute;left:.5em;text-align:left;bottom:.5em}.ol-control.ol-overview .panel{display:block;width:150px;height:150px;margin:2px;background-color:#fff;border:1px solid #369;cursor:pointer}.ol-overview:not(.ol-collapsed) button{position:absolute;bottom:2px;left:2px;z-index:2}.ol-control.ol-overview.ol-collapsed .panel{display:none}.ol-overview.ol-collapsed button:before{content:\"\\BB\"}.ol-overview button:before{content:\"\\AB\"}.ol-control-right.ol-overview{left:auto;right:.5em}.ol-control-right.ol-overview:not(.ol-collapsed) button{left:auto;right:2px}.ol-control-right.ol-overview.ol-collapsed button:before{content:\"\\AB\"}.ol-control-right.ol-overview button:before{content:\"\\BB\"}.ol-control-top.ol-overview{bottom:auto;top:5em}.ol-control-top.ol-overview:not(.ol-collapsed) button{bottom:auto;top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/ol/control/Overview.css
// module id = 263
// module chunks = 0